<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-monitoramento
      :acesso="acesso"
      monitoramento="desempenho"
      titulo="Coeficiente de Desempenho do Servidor (CDS)"
    >
      <template v-slot:body>
        <!-- Usuário não é da comissão e o desempenho ainda não iniciou -->
        <v-col v-if="desempenhoNaoDisponivel">
          <app-alert
            :message="mensagemDesempenhoNaoDisponivel"
            type="info"
          />
        </v-col>

        <!-- Diagnóstico iniciou -->
        <v-col
          v-else
          centered
          cols="12"
          no-gutters
        >
          <v-row class="justify-center ma-2">
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-row
            v-if="categoria === 'ComparativoCoeficiente'"
            class="justify-start ml-2 mr-2"
          >
            <v-col cols="12">
              <v-tooltip
                max-width="500"
                top
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <select-multiple-unidades
                      v-model="filtros.unidades"
                      :mapeamento-id="diagnostico.mapeamento.id"
                    />
                  </div>
                </template>
                <div>
                  Selecione para carregar os dados de outra unidade.
                  <span
                    style="color: #9fdfeb"
                  >É possível pesquisar digitando o nome ou a sigla da
                    unidade</span>
                  <v-icon
                    class="mr2"
                    color="#9FDFEB"
                    size="22"
                  >
                    info
                  </v-icon>
                </div>
              </v-tooltip>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-tooltip
                max-width="500"
                top
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-select
                      v-model="filtros.tipo"
                      :disabled="!cdsViabilizado"
                      :items="filtros.tipos"
                      item-text="text"
                      item-value="id"
                      label="Categoria:"
                      prepend-icon="person"
                      @input="filterDesempenhos"
                    />
                  </div>
                </template>
                <div>
                  Selecione para filtrar os dados por tipo.
                  <span
                    style="color: #9fdfeb"
                  >É possível ver todos os dados selecionando "Todos"</span>
                  <v-icon
                    class="mr2"
                    color="#9FDFEB"
                    size="22"
                  >
                    info
                  </v-icon>
                </div>
              </v-tooltip>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="12"
            >
              <v-tooltip
                bottom
                max-width="500"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-autocomplete
                      v-model="filtros.desempenho"
                      :disabled="!cdsViabilizado"
                      :items="filtros.desempenhos"
                      item-text="usuario.nome"
                      label="Servidor:"
                      placeholder="Digite para pesquisar..."
                      prepend-icon="supervisor_account"
                      return-object
                    />
                  </div>
                </template>
                <span>{{ tooltipServidores }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row class="justify-center ma-1">
            <v-col
              v-if="cdsViabilizado || categoria !== 'ComparativoCoeficiente'"
              cols="12"
            >
              <keep-alive>
                <component
                  :is="categoria"
                  :desempenhos="desempenhosServidores"
                  :unidades="filtros.unidades.visualizacao"
                  :diagnostico="diagnostico"
                  tipo="UNIDADE"
                  menu-acesso="MONITORAMENTO"
                />
              </keep-alive>
            </v-col>
            <v-col v-else-if="filtros.unidades.selecionado.length > 0">
              <app-alert
                message="Não há CDS viabilizados na unidade."
                type="info"
              />
            </v-col>
          </v-row>
        </v-col>
      </template>
    </app-monitoramento>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppMonitoramento from '@/components/core/AppMonitoramento';
import AppAlert from '@/components/core/AppAlert';
import SelectMultipleUnidades from '@/components/SelectMultipleUnidades';
import ComparativoCoeficiente from '@/components/desempenho/ComparativoCoeficiente';
import RelatorioGerencial
from '@/views/monitoramento/desempenho/coeficiente/tabs/RelatorioGerencialCoeficienteDesempenho';
import RelatorioGerencialUnidade
from '@/views/monitoramento/desempenho/coeficiente/tabs/RelatorioGerencialCoeficienteDesempenhoUnidade';
import Data from '@/modules/data';

export default {
  name: 'MonitoramentoCoeficienteDesempenho',

  components: {
    AppMonitoramento,
    AppAlert,
    SelectMultipleUnidades,
    ComparativoCoeficiente,
    RelatorioGerencial,
    RelatorioGerencialUnidade,
  },

  data() {
    return {
      acesso: null,
      categoria: '',
      filtros: {
        unidades: {
          isTodasSelecionadas: null,
          selecionado: [],
          visualizacao: '',
        },
        desempenhos: [],
        desempenho: {
          id: null,
          usuario: { nome: 'Todos' },
        },
        tipos: [
          { id: '', text: 'Todas' },
          { id: 'GESTOR', text: 'Gestor' },
          { id: 'SERVIDOR', text: 'Servidor' },
        ],
        tipo: '',
      },
    };
  },

  computed: {
    ...mapState({
      isTutorialExibido: (state) => state.tutorial.dados.monitoramentoCoeficienteDesempenho,
      usuario: (state) => state.auth.usuario,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
    ...mapGetters({
      getDiagnostico: 'diagnostico/getDiagnostico',
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    diagnostico() {
      return this.getDiagnostico(this.acesso);
    },
    desempenhoNaoDisponivel() {
      // Retorna verdadeiro se o usuário não for da comissão e o desempenho ainda não tiver iniciado
      // Se for da comissão os dados de desempenho poderam ser acessados
      return this.acesso === 'COMUM'
        && this.diagnostico && Data.compare('isBefore', { b: this.diagnostico.inicioDesempenho });
    },
    mensagemDesempenhoNaoDisponivel() {
      return `Desempenho ainda não disponível. Início em ${Data.format(this.diagnostico.inicioDesempenho)}.`;
    },
    categorias() {
      const categorias = [
        {
          id: 'ComparativoCoeficiente',
          descricao: 'CDS dos Servidores',
          icone: 'group',
        },
        {
          id: 'RelatorioGerencialUnidade',
          descricao: 'Relatórios Gerenciais por Unidade',
          icone: 'account_balance',
        },
      ];

      if (this.unidades.length > 1 || this.acesso === 'COMISSAO') {
        categorias.splice(1, 0, {
          id: 'RelatorioGerencial',
          descricao: 'Relatórios Gerenciais',
          icone: 'account_balance',
        });
      }
      return categorias;
    },
    unidades() {
      return this.getUnidadesByAcesso(this.acesso, this.diagnostico.mapeamento.id);
    },
    desempenhos() {
      return this.$store.state.monitoramentoDesempenho.desempenhos;
    },
    desempenhosServidores() {
      return this.desempenhos.filter(
        (d) => !d.inviabilizado
          && this.filtros.unidades.selecionado.some((u) => u.idVersao === d.unidade.id)
          && (this.filtros.tipo === ''
            || (this.filtros.tipo === 'GESTOR' && d.chefia)
            || (this.filtros.tipo === 'SERVIDOR' && !d.chefia))
          && (!this.filtros.desempenho.id || d.id === this.filtros.desempenho.id),
      );
    },
    cdsViabilizado() {
      return this.desempenhosServidores.length > 0;
    },
    tooltipServidores() {
      if (this.desempenhosServidores.length === 0) {
        return 'Não há CDS viabilizados na unidade';
      }
      return 'Selecione para carregar os dados referentes a outro servidor';
    },
  },

  watch: {
    diagnostico() {
      if (!this.desempenhoNaoDisponivel) {
        const payload = {
          diagnostico: this.diagnostico,
          comissao: this.acesso === 'COMISSAO',
        };
        this.$store.dispatch('monitoramentoDesempenho/load', payload);
      }
    },
    'filtros.unidades.selecionado': function () {
      this.filterDesempenhos();
    },
  },

  created() {
    if (this.comissao) {
      this.acesso = 'COMISSAO';
    } else if (this.chefia || this.substituicaoChefia) {
      this.acesso = 'COMUM';
    }

    if (!this.isTutorialExibido && this.acesso) {
      let tutorial = '';
      if (this.unidades.length > 1 || this.acesso === 'COMISSAO') {
        tutorial = 'MonitoramentoCoeficienteDesempenhoGeral';
      } else {
        tutorial = 'MonitoramentoCoeficienteDesempenhoUnidade';
      }
      this.$store.dispatch('app/showTutorial', {
        nome: tutorial,
        nomeGenerico: 'MonitoramentoCoeficienteDesempenho',
      });
    }
  },

  methods: {
    filterDesempenhos() {
      this.filtros.desempenho = { id: null, usuario: { nome: 'Todos' } };
      const desemepenhos = this.desempenhos.filter(
        (d) => !d.inviabilizado
          && this.filtros.unidades.selecionado.some((u) => u.idVersao === d.unidade.id)
          && (this.filtros.tipo === ''
            || (this.filtros.tipo === 'GESTOR' && d.chefia)
            || (this.filtros.tipo === 'SERVIDOR' && !d.chefia)),
      );
      this.filtros.desempenhos = [{ id: null, usuario: { nome: 'Todos' } }, ...desemepenhos];
    },
    formatSiglaNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
  },
};
</script>
